import React, { useState, useEffect } from 'react';

function VehicleModal({
  isOpen,
  onClose,
  onSave,
  vin,
  setVin,
  category,
  handleCategoryChange,
  logging,
  setLogging,
  taxAmount,
  isAgricultural = false,
  setIsAgricultural,
  weightCategories,
  knownVins = [],
  onPickKnownVin,
}) {
  const [vinError, setVinError] = useState('');

  useEffect(() => {
    // Валидируем VIN при изменении
    if (vin === '') {
      setVinError('VIN is required');
    } else if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
      setVinError('VIN must be 17 alphanumeric characters (no I, O, Q)');
    } else {
      setVinError('');
    }
  }, [vin]);

  if (!isOpen) return null;

  const handleVinChange = (e) => {
    const value = e.target.value.toUpperCase();
    setVin(value);
  };

  const handleSaveClick = () => {
    if (vinError) return;
    onSave();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md border border-gray-300 px-6 py-4">
        <h2 className="text-lg font-bold mb-3 text-[#0F2C5E]">Add Vehicle</h2>

        {/* Previous VINs */}
        {knownVins.length > 0 && (
          <div className="mb-3">
            <label className="block mb-1 font-medium text-sm">
              Use a previous VIN
            </label>
            <select
              value=""
              onChange={(e) => {
                const picked = knownVins.find(kv => kv.vin === e.target.value);
                if (picked && onPickKnownVin) onPickKnownVin(picked);
              }}
              className="w-full p-2 border border-gray-300 focus:outline-none text-sm"
            >
              <option value="">— choose from previous VINs —</option>
              {knownVins.map(kv => (
                <option key={kv.vin} value={kv.vin}>
                  {kv.vin}
                  {kv.gross_vehicle_label ? ` — Cat ${kv.gross_vehicle_label}` : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* VIN */}
        <div className="mb-3">
          <label className="block mb-1 font-medium text-sm">VIN</label>
          <input
            type="text"
            value={vin}
            onChange={handleVinChange}
            maxLength={17}
            className={`w-full p-2 border ${
              vinError ? 'border-red-500' : 'border-gray-300'
            } focus:outline-none`}
          />
          {vinError && <p className="text-red-600 text-xs mt-1">{vinError}</p>}
        </div>

        {/* Weight Category */}
        <div className="mb-3">
          <label className="block mb-1 font-medium text-sm">Weight Category</label>
          <select
            value={category}
            onChange={handleCategoryChange}
            className="w-full p-2 border border-gray-300 focus:outline-none"
          >
            <option value="">-- Select Weight Category --</option>
            {weightCategories.map((cat) => (
              <option key={cat.letter} value={cat.letter}>
                {cat.letter === 'W'
                  ? 'Category W: Tax Suspended Vehicle — $0'
                  : `Category ${cat.letter}: ${cat.range} lbs — $${cat.tax}`}
              </option>
            ))}
          </select>
        </div>

        {/* Suspension mileage limit (category W only) */}
        {category === 'W' && (
          <div className="mb-3 p-3 bg-blue-50 border border-blue-200 text-sm">
            <p className="text-gray-700 mb-2">
              Tax suspended: the vehicle is expected to be used on public
              highways within the mileage limit during the period. No tax is due.
            </p>
            <label className="flex items-center gap-2 mb-1">
              <input
                type="radio"
                name="suspension-limit"
                checked={!isAgricultural}
                onChange={() => setIsAgricultural && setIsAgricultural(false)}
              />
              <span>Standard — 5,000 miles or less</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="suspension-limit"
                checked={isAgricultural}
                onChange={() => setIsAgricultural && setIsAgricultural(true)}
              />
              <span>Agricultural — 7,500 miles or less</span>
            </label>
          </div>
        )}

        {/* Logging */}
        <div className="mb-3">
          <label className="block mb-1 font-medium text-sm">Logging (if applicable)</label>
          <input
            type="text"
            value="No"
            readOnly
            className="w-full p-2 border border-gray-300 bg-gray-100 cursor-not-allowed focus:outline-none text-sm"
          />
        </div>

        {/* Tax Amount */}
        <div className="mb-4">
          <label className="block mb-1 font-medium text-sm">Tax Amount</label>
          <input
            type="text"
            value={`$${taxAmount}`}
            readOnly
            className="w-full p-2 border border-gray-300 bg-gray-100 focus:outline-none"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-sm hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSaveClick}
            disabled={!!vinError || !category}
            className={`px-4 py-2 text-white text-sm transition ${
              vinError || !category
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-[#0F2C5E] hover:bg-[#0F2C5E]/80'
            }`}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default VehicleModal;

